import { render } from "./MainScreen.vue?vue&type=template&id=ca1bc010"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"

import "./MainScreen.vue?vue&type=style&index=0&id=ca1bc010&lang=css"
script.render = render

export default script